export default __webpack_public_path__ + "static/media/sort-za.4fdf9eda.svg";